import { Box, useTheme, Typography } from "@mui/material";
import React from "react";
import { tokens } from "../../Theme/theme";
import ProgressCircle from "./ProgressCircle";
import HdrStrongRoundedIcon from '@mui/icons-material/HdrStrongRounded';
import '../../assets/fonts/fonts.css'
import {
  TrendingUpRounded,
  TrendingDownRounded
} from '@mui/icons-material';
import { CircleLoader, BounceLoader } from 'react-spinners'


const Statbox = ({ title, subtitle, titleTextSize = "", subtitleTextSize = "", icon, progress, report, reportSuffix, users, onClick, loading = false, showIcon = true }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box width={"100%"} ml="20px" mr={"20px"} mt={"0px"} mb={"0px"} onClick={() => {
      if (onClick) {
        onClick()
      }
    }} >
      <Box display={"flex"} justifyContent="space-between">
        <Box>
          <Typography
            variant={subtitleTextSize ? undefined : "h6"}
            // fontWeight={"italic"}
            fontFamily={"poppins-reg"}
            sx={{ fontSize: subtitleTextSize ? subtitleTextSize : undefined, color: "#ffffff90" }}
          >
            {subtitle}
          </Typography>



          <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', marginTop: "3px" }}>

            {
              !loading ? (
                <Typography
                  fontSize={titleTextSize ? titleTextSize : "26px"}
                  fontFamily={'poppins-mid'}
                  sx={{ color: "#ffffff" }}
                >
                  {title}
                </Typography>
              ) : (
                <Box sx={{ marginTop: "8px", }}>
                  <CircleLoader size={"30px"} color={"#943bff"} />
                </Box>
              )
            }



            {
              ((users && report) || (report > 0 || report < 0)) && (
                <Box sx={{
                  display: 'flex', flexDirection: 'row', gap: "4px", alignItems: 'center', background: users ? "#aaaaaa15" : report < 0 ? "#ff220015" : "#03fc0b15",
                  marginLeft: "10px", paddingInline: "6px", paddingBlock: "4px", borderRadius: "3px", border: `0px solid ${users ? "#aaaaaa20" : report < 0 ? "#ff220020" : "#03fc0b20"}`
                }}>
                  {
                    !users && report < 0 && (
                      <TrendingDownRounded style={{ color: "#ff2200", fontSize: "18px" }} />
                    )
                  }
                  {
                    !users && report > 0 && (
                      <TrendingUpRounded style={{ color: "#03fc0b", fontSize: "18px" }} />
                    )
                  }
                  <Typography sx={{ fontSize: "12px", fontFamily: 'poppins-reg', color: users ? "#ffffff90" : report < 0 ? "#ff2200" : "#03fc0b" }}>
                    {users ? `${report}` : (report > 0 ? `${report}%` : `${Math.abs(report)}%`)}
                  </Typography>
                </Box>
              )
            }
          </Box>

        </Box>
        <Box>
          {
            showIcon && (
              <HdrStrongRoundedIcon color="#ffffff10" />
            )
          }
        </Box>
      </Box>


    </Box>
  );
};

export default Statbox;
